<template>
  <div>
    <!-- Create Post -->
    <v-card>
      <v-card-title>Create {{ boardType }}</v-card-title>
      <v-card-text>
<!--        <v-text-field label="Board Id" v-model="selectedBoard.boardId" />-->
        <v-text-field label="Title" v-model="selectedBoard.title" />

        <v-textarea
            :rules="minimumLengthRule"
            counter
            filled

            rows="7"
            row-height="12"

            label="소중한 수강후기를 남겨주세요. (10자 이상)"
            placeholder=""
            :value="review.reviewText"
            v-model="review.reviewText"
        >
        </v-textarea>

        <v-card-actions>
          평점
          <v-spacer></v-spacer>
          <v-rating
              empty-icon="$mdiStarOutline"
              full-icon="$mdiStar"
              half-icon="$mdiStarHalfFull"

              half-increments
              hover
              length="5"
              size="20"
              v-model="review.rating"
              color="yellow darken-3"
              background-color="grey darken-1"
          ></v-rating>
        </v-card-actions>

        <v-textarea
            counter
            filled

            rows="7"
            row-height="12"

            label="이용하시면서 불편했던 점을 남겨주세요."
            placeholder="개선할 수 있는 부분은 최대한 반영하겠습니다. 감사합니다 :)"
            :value="review.feedback"
            v-model="review.feedback"
        >
        </v-textarea>
        <v-textarea label="Content" v-model="selectedBoard.content1" />
        <v-textarea label="Author" v-model="selectedBoard.content2" />
      </v-card-text>
      <v-card-actions v-if="isOwner">
        <v-spacer />
        <v-btn v-if="!selectedBoard.id" color="primary" @click="saveBoard">Create</v-btn>
        <v-btn v-if="selectedBoard.id"  icon @click="deleteBoard(selectedBoard)"><v-icon>mdi-delete</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import apiBoard from "@/api/modules/api-board";
import {parseDate} from "@/utils/common_date";

export default {
  data() {
    return {
      min: 10,
      rating: 3,
      searchQuery: {
        orderId: ''
      },
      assign: {},
      review: {
        rating: 4.5,
        reviewText: '',
        feedback: ''
      },
    };
  },
  props: {
    selectedBoard: {type: Object, default: []},
    boardType: {type: String, default: 'Post'}
  },
  created() {  },
  beforeMount() {  },
  async mounted() { },
  watch: {
  },
  destroyed() {
    this.selectedBoard = null
  },

  filters: { },
  computed: {
    minimumLengthRule() {
      const rules = []
      if (this.min) {
        const rule = v => (v || '').length >= this.min ||
            `최소 ${this.min}자 이상은 작성 부탁드릴게요! :) `
        rules.push(rule)
      }
      return rules
    },
    endDate() {
      return this.assign ? parseDate(this.assign.endDate, '{y}-{m}-{d}') : ''
    },
  },
  methods: {
    async saveBoard() {
        await apiBoard.saveBoard(this.selectedBoard)
          .then(res => {
            this.$emit('saveBoard', res)
            this.$destroy()
          });
    },
    async deleteBoard(selectedBoard) {
      await apiBoard.deleteBoard(selectedBoard.id)
        .then(res => {
          this.$emit('deleteBoard', res)
          this.$destroy()
        })
    },
  },
};
</script>
